import { useContext } from "react";

import { EventContext } from "../../contexts/user/EventContext";

const useEvent = () => {
  const context = useContext(EventContext);

  if (!context) throw new Error("EventContext must be placed within EventProvider");

  return context;
};

export default useEvent;
